// extracted by mini-css-extract-plugin
export default {"horizontalTopMenu":"ScrollableTabs_horizontalTopMenu__yrb-h","wrapper":"ScrollableTabs_wrapper__dEg4w"};